import { ConditionEvaluator } from '@leverege/condition';
export default class ExistsComparatorEvaluator extends ConditionEvaluator {
  satisfies(context) {
    const {
      attribute,
      target
    } = context;
    const targetValue = attribute?.get(target?.data);
    return targetValue != null;
  }
}